import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    timeout: 10000,
});

instance.interceptors.request.use(
    (config) => {
        if (config.headers["token"]) {
            const token = localStorage.getItem("access_token");
            if (token) {
                config.headers["Authorization"] = "Bearer " + token;
            }
        }
        config.headers["X-Client-Type"] = "WEB-ERP"
        return config;
    },
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const allowedPaths = ["/login", "/auth/find", "/auth/signup", "/mobile/contract"];
            
            const currentPath = window.location.pathname;
            if (!allowedPaths.some(path => currentPath.startsWith(path))) {
                localStorage.removeItem("access_token");
                localStorage.removeItem("loginId");
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
